var _defs, _path, _path2, _path3, _circle, _use, _use2, _use3, _use4, _path4, _path5, _use5, _use6, _use7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-gd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(18 0 -1)",
    d: "M0-1v1h.5",
    id: "a",
    fill: "#fcd116"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#b",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    xlinkHref: "#b",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-144)",
    xlinkHref: "#b",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-72)",
    xlinkHref: "#b",
    width: "100%",
    height: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 .05h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M71.68 71.677h368.64v368.64H71.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.68 71.73h368.64L71.68 440.37h368.64z",
    fill: "#fcd116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.911,
    cy: 256.05,
    r: 61.44,
    fill: "#ce1126"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#c",
    transform: "translate(255.911 256.05) scale(56.32)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    x: -100,
    transform: "translate(-16.349 -.1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    id: "d",
    xlinkHref: "#c",
    transform: "translate(256 35.89) scale(33.28)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    x: 100,
    transform: "translate(16.35)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.803 256.75c7.687 14.319 22.639 29.9 35.696 35.379.21-14.54-4.949-33.178-12.004-48.026L99.803 256.75z",
    fill: "#ce1126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.769 207.632c11.143 23.228-28.9 78.643 37.813 91.63-8.23-11.23-13.536-29.763-11.529-44.646 13.997 5.325 28.723 20.907 34.675 32.82 17.459-63.403-44.783-59.546-60.96-79.804z",
    fill: "#fcd116"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-16.349 442.086)",
    x: -100,
    xlinkHref: "#d",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(256 478.076) scale(33.28)",
    xlinkHref: "#c",
    width: "100%",
    height: "100%"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(16.35 442.186)",
    x: 100,
    xlinkHref: "#d",
    width: "100%",
    height: "100%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.71f68a5b8208cdf6234073b4bff12f91.svg";
export { ForwardRef as ReactComponent };